<template>
  <div class="w-full px-4 py-6 mb-1 pb-0">
    <div class="w-full flex gap-3 p-3 rounded-md bg-white/10">
      <div class="grow w-32">
        <h2 class="text-xs font-semibold text-white">Scope Content To</h2>
        <p class="text-white/80 truncate text-sm">{{ selectedName }}</p>
      </div>

      <NtButton level="primary" icon="fa-location-crosshairs" @click="$refs.modal.open()" />
    </div>
  </div>

  <NtModal ref="modal" heading="Scope" @opened="uncommittedScope = selectedScope">
    <NtSpacing>
      <p>
        You can scope all content on the admin hub to a single network, client or office by selecting from the list
        below.
      </p>
      <NtComboBox
        :options="scopes"
        v-model="uncommittedScope"
        placeholder="No Scope"
        :max-results="100"
        wrap
        nullable />
    </NtSpacing>

    <template #footer>
      <NtButton level="primary" icon="fa-location-crosshairs" @click="applyScope"> Set Scope </NtButton>
      <NtButton v-if="localScope" level="secondary" icon="fa-times" @click="removeScope"> Remove Scope </NtButton>
    </template>
  </NtModal>
</template>

<script>
import { useSystemStore } from '@/stores/system'
import { mapActions, mapState } from 'pinia'
import NtButton from '../general/NtButton.vue'
import NtModal from '../general/NtModal.vue'
import NtSpacing from '../general/NtSpacing.vue'
import NtComboBox from '../forms/NtComboBox.vue'

export default {
  components: { NtButton, NtModal, NtSpacing, NtComboBox },
  data() {
    return {
      uncommittedScope: this.selectedScope
    }
  },
  computed: {
    ...mapState(useSystemStore, ['scopes', 'selectedScope']),
    localScope: {
      get() {
        return this.selectedScope
      },
      set(scope) {
        this.setScope(scope)
      }
    },
    selectedName() {
      return this.scopes.find((s) => s.id === this.localScope)?.name || 'All offices'
    }
  },
  methods: {
    ...mapActions(useSystemStore, ['setScope']),
    applyScope() {
      this.setScope(this.uncommittedScope)
      this.$refs.modal.close()
    },
    removeScope() {
      this.setScope(null)
      this.$refs.modal.close()
    }
  }
}
</script>
